export interface SupervisionParameters {
    time_limit_minutes: number;
    gap: number;
    experience: number;
    involvement: number;
    language: number;
    affiliation: number;
    location: number;
    holiday: number;
    violations: number;
    exam_phase: number;
    workload: number;
    admin_assignment: number;
    admin_exclusion: number;
    retake_exam_only: number;
}

export interface CorrectionParameters {
    time_limit_minutes: number;
    gap: number;
    experience: number;
    involvement: number;
    language: number;
    affiliation: number;
    teaching_assistant: number;
    violations: number;
    exam_phase: number;
    workload: number;
    spread: number;
    field: number;
}

export interface ParameterSetRequest {
    name: string;
    supervision: SupervisionParameters;
    correction: CorrectionParameters;
}

export interface ParameterSetResponse extends ParameterSetRequest {
    id: number;
    owner_id: number;
}

export class ParameterSet {
    name: string;
    supervision: Map<string, number>;
    correction: Map<string, number>;

    constructor(name: string,
                supervision: Map<string, number>,
                correction: Map<string, number>)
    {
        this.name = name;
        this.supervision = supervision;
        this.correction = correction;
    }

    static from(params: ParameterSetRequest): ParameterSet {
        const name = params.name;
        const supervision = new Map(Object.entries(params.supervision));
        const correction = new Map(Object.entries(params.correction));
        return new ParameterSet(name, supervision, correction);
    }

    setTo(params: ParameterSetRequest): void {
        this.name = params.name;
        this.supervision = new Map(Object.entries(params.supervision));
        this.correction = new Map(Object.entries(params.correction));
    }

    toRequest(name: string | null = null): ParameterSetRequest {
        const sup = this.supervision;
        const corr = this.correction;

      let newName = this.name;
      if(name)
          newName = name;
        return {
            name: newName,
            supervision: {
                time_limit_minutes: sup.get('time_limit_minutes') || 0,
                gap: sup.get('gap') || 0,
                experience: sup.get('experience') || 0,
                involvement: sup.get('involvement') || 0,
                language: sup.get('language') || 0,
                affiliation: sup.get('affiliation') || 0,
                location: sup.get('location') || 0,
                holiday: sup.get('holiday') || 0,
                violations: sup.get('violations') || 0,
                exam_phase: sup.get('exam_phase') || 0,
                workload: sup.get('workload') || 0,
                admin_assignment: sup.get('admin_assignment') || 0,
                admin_exclusion: sup.get('admin_exclusion') || 0,
                retake_exam_only: sup.get('retake_exam_only') || 0
            },
            correction: {
                time_limit_minutes: corr.get('time_limit_minutes') || 0,
                gap: corr.get('gap') || 0,
                experience: corr.get('experience') || 0,
                involvement: corr.get('involvement') || 0,
                language: corr.get('language') || 0,
                affiliation: corr.get('affiliation') || 0,
                teaching_assistant: corr.get('teaching_assistant') || 0,
                violations: corr.get('violations') || 0,
                exam_phase: corr.get('exam_phase') || 0,
                workload: corr.get('workload') || 0,
                spread: corr.get('spread') || 0,
                field: corr.get('field') || 0
            }
        }
    }
}
